export const consts = {
    minBoxValue: "1500000",
    ergoFee: "1100000",
    adaFeeCoef: "44",
    adaFeeConstant: "255381",
    adaPoolDeposit: "500000000",
    adaKeyDeposit: "2000000",
    adaMinCoin: "34482",
    adaMaxValueSize: 5000,
    adaMaxTxSize: 16384,
    nautilusUrl: "https://github.com/capt-nemo429/nautilus-wallet#download",
    namiUrl: "https://namiwallet.io/",
    feeRatio: 0.01,
    nextfeeHeight: 5,
    ergTokenName: "erg",
    ergTokenNameEIP12: "ERG",
    cardanoTokenName: "lovelace",
    minBoxADA: "1000000",
    defaultPageLength: 15,
    supportedChains: [
        { id: "ERG", label: "Ergo", icon: "ERG.svg", tokenmap_name: "ergo" },
        { id: "ADA", label: "Cardano", icon: "ADA.svg", tokenmap_name: "cardano" }
    ]
};
